import { render, staticRenderFns } from "./OrbitStartRoundModal.vue?vue&type=template&id=6276e58c"
import script from "./OrbitStartRoundModal.vue?vue&type=script&lang=ts"
export * from "./OrbitStartRoundModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitStartRoundModal.vue?vue&type=style&index=0&id=6276e58c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports